<template>
  <div>
    <sidebar :sideBarData="sidebarData" />
    <img v-lazy="require('@/img/izixun/service/header.png')" class="header" />
    <div id="serviceId1">
      <pageTitle title="专属服务，为学习保驾护航" subTitle="全程跟进与服务、及时反馈与沟通，让您更了解孩子学习情况" />
      <div class="part1-content">
        <div>
          <img v-lazy="require('@/img/izixun/service/part1-1.png')" />
          <p>专属班主任服务</p>
        </div>
        <div>
          <img v-lazy="require('@/img/izixun/service/part1-2.png')" />
          <p>课后及时反馈</p>
        </div>
        <div>
          <img v-lazy="require('@/img/izixun/service/part1-3.png')" />
          <p>周中伴学答疑</p>
        </div>
        <div>
          <img v-lazy="require('@/img/izixun/service/part1-4.png')" />
          <p>阶段诊断沟通</p>
        </div>
        <div>
          <img v-lazy="require('@/img/izixun/service/part1-5.png')" />
          <p>学期结课报告</p>
        </div>
        <div>
          <img v-lazy="require('@/img/izixun/service/part1-6.png')" />
          <p>专家政策讲座</p>
        </div>
      </div>
    </div>
    <div id="serviceId2" class="part2">
      <pageTitle title="我们的承诺" subTitle="承诺的背后是我们的信心与用心" />
      <div class="part2-box">
        <div class="part2-content">
          <ul class="part2-content-left">
            <li>
              <div><img v-lazy="require('@/img/izixun/service/part2-1.png')" style="width: 48px;" /></div>
              <div>
                <h4>上市机构 值得信赖</h4>
                <p>学而思1对1，好未来生团(TAL)旗下教育1对1辅导品牌，为国内6-18岁中小学生提供个性化学习服务。</p>
              </div>
            </li>
            <li>
              <div><img v-lazy="require('@/img/izixun/service/part2-2.png')" style="width: 54px;" /></div>
              <div>
                <h4>旁听制度 家长放心</h4>
                <p>学而思1对1所有学习中心均实行线上和线下家长旁听制度，孩子学习中的每一点进步，您都能全程参与。</p>
              </div>
            </li>
            <li>
              <div><img v-lazy="require('@/img/izixun/service/part2-3.png')" style="width: 48px;" /></div>
              <div>
                <h4>如有不满 退还余费</h4>
                <p>孩子学习能力的提升是我们追求的目标，只要您有不满，我们随时退还剩余学费。</p>
              </div>
            </li>
          </ul>
          
        </div>
        <div class="part2-content-right">
          <img v-lazy="require('@/img/izixun/service/part2-teacher.png')" />
        </div>
      </div>
    </div>
    <div class="part3" id="serviceId3">
      <pageTitle title="整洁舒适的教学环境" subTitle="愉悦的心情进入学习中心，愉悦的状态进入课堂" />
      <div class="part3-bac"><img v-lazy="require('@/img/izixun/service/part3-2.png')" /></div>
      <div class="part3-class1">
        <div class="part3-class1-header" />
        <div class="part3-class1-content">
          <h4>整体装修</h4>
          <span class="ornament" />
          <p>学习中心装修使用安全环保材料，让孩子在优质的环境中学习。</p>
        </div>
      </div>
      <div class="part3-class2">
        <div class="part3-class2-cont">
          <div />
          <h4>休息区</h4>
          <span class="ornament" />
          <p>家长可在学习中心休息区进行等待，也可参与旁听，及时了解孩子学习情况。</p>
        </div>
        <div class="part3-class2-cont">
          <div />
          <h4>自习室</h4>
          <span class="ornament" />
          <p>学而思1对1学习中心优先为学员免费开放的自习室，供学员使用。</p>
        </div>
        <div class="part3-class2-cont">
          <div />
          <h4>1对1教室</h4>
          <span class="ornament" />
          <p>1对1辅导教室，安静的氛围，整洁的环境，室内摄像系统，让家长随时了解上课情况。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "./components/pageTitle.vue";
import sidebar from "./components/sidebar.vue";
import Vue from 'vue';
import { Lazyload } from 'mint-ui';
Vue.use(Lazyload);
export default {
  name: "service",
  components: {
    pageTitle,
    sidebar
  },
  data() {
    return {
      sidebarData: [
        {
          id: 'serviceId1',
          value: '专属服务'
        },
        {
          id: 'serviceId2',
          value: '服务承诺'
        },
        {
          id: 'serviceId3',
          value: '教学环境'
        }
      ]
    };
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.part1-content {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  div {
    float: left;
    width: 200px;
    height: 208px;
    text-align: center;
    padding-top: 50px;
    border-top: 4px solid transparent;

    img {
      width: 100px;
      height: 100px;
    }
    p {
      font-size: 18px;
      font-weight: 400;
      color: #222222;
      line-height: 25px;
      margin-top: 37px;
    }
    &:hover {
      background: linear-gradient(180deg, #F8F9FB 0%, #FFFFFF 100%);
      border-color: #CD0014;
    }
  }
}
.part2-box {
  background: #F8F9FB;
  width: 100%;
  position: relative;
  overflow-x: clip;
  .part2-content {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    padding: 50px 0;
    .part2-content-left {
      width: 700px;
      li {
        height: 140px;
        display: flex;
        align-items: center;
        padding-left: 41px;
        border-left: 4px solid transparent;
        margin: 10px 0;
        div:first-child {
          width: 96px;
          height: 96px;
          border-radius: 50%;
          border: 1px dotted #222222;
          text-align: center;
        }
        img {
          position: relative;
          top: 50%;
          transform: translateY(-50%);
        }
        div:last-child {
          width: 440px;
          padding-left: 30px;
          margin-top: -5px;
        }
        h4 {
          font-size: 24px;
          font-weight: 500;
          color: #222222;
          line-height: 33px;
        }
        p {
          font-size: 16px;
          font-weight: 300;
          color: #666666;
          line-height: 22px;
          margin-top: 8px;
        }
        &:hover {
          background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
          border-left-color: #CD0014;
        }
      }
    }
    
  }
  .part2-content-right {
    width: 837px;
    height: 461px;
    background: linear-gradient(270deg, rgba(236, 239, 244, 0.19) 0%, #ECEFF4 100%);
    border-radius: 105px 0px 0px 0px;
    position: absolute;
    bottom: 0;
    left: calc(50% + 120px);
    img {
      position: absolute;
      width: 392px;
      left: 23px;
      bottom: 0;
    }
  }
  
}
.part3 {
  position: relative;
  &::after {
    content: " ";
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: -1;
    width: 100%;
    height: 357px;
    background: #F8F9FB;
  }
}
.part3-bac {
  position: relative;
  overflow-x: clip;
  img {
    position: absolute;
    width: 616px;
    top: 0;
    left: calc(50% + 344px);
  }
}
.part3-class1 {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  .part3-class1-header {
    background: url('../../img/izixun/service/part3-1.png') center no-repeat;
    background-size: 100% 100%;
    width: 916px;
    height: 362px;
    transition: background-size 0.3s;
    &:hover {
      background-size: 120% 120%;
    }
  }
  .part3-class1-content {
    position: absolute;
    right: 0;
    bottom: 30px;
    width: 378px;
    height: 144px;
    background: #CD0014;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    padding: 38px 29px 0 37px;
    h4 {
      font-size: 22px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 30px;
    }
    p {
      font-size: 16px;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 20px;
    }
    /deep/ span {
      background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
      margin: 11px 0 18px;
    }
  }
}
.part3-class2 {
  padding: 60px 0 80px;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
  .part3-class2-cont:nth-child(1) div {
    background: url('../../img/izixun/service/part3-3.png') center no-repeat;
    background-size: 100% 100%;
  }
  .part3-class2-cont:nth-child(2) div {
    background: url('../../img/izixun/service/part3-4.png') center no-repeat;
    background-size: 100% 100%;
  }
  .part3-class2-cont:nth-child(3) div {
    background: url('../../img/izixun/service/part3-5.png') center no-repeat;
    background-size: 100% 100%;
  }
  .part3-class2-cont {
    width: 360px;
    div{
      width: 100%;
      height: 263px;
      overflow: hidden;
      transition: background-size 0.3s;
      &:hover {
        background-size: 120% 120%;
      }
    }
    h4 {
      font-size: 22px;
      font-weight: 500;
      color: #222222;
      line-height: 30px;
      margin: 35px 0 6px;
    }
    p {
      font-size: 16px;
      font-weight: 300;
      color: #666666;
      line-height: 20px;
      margin-top: 20px;
    }
  }
}
</style>